import { Modal, ModalBody, ModalCloseButton, ModalContent, ModalOverlay } from '@chakra-ui/react';
import React from 'react';
import { IModalProps } from './Modal';

const paddings = (withPaddings: boolean) => (withPaddings ? { p: 'xl', pt: '2xl' } : { p: 0 });

const ModalDesktop: React.FC<IModalProps> = ({
  maxW,
  size = 'lg',
  children,
  withCloseButton = true,
  withPaddings = true,
  contentProps,
  ...props
}) => {
  const max = maxW ? { maxW } : {};

  return (
    <Modal
      isCentered
      blockScrollOnMount={false}
      scrollBehavior='inside'
      size={size}
      {...props}
    >
      <ModalOverlay />
      <ModalContent
        overflow='hidden'
        {...max}
        {...contentProps}
        {...paddings(withPaddings)}
      >
        {withCloseButton && <ModalCloseButton zIndex='20' />}
        <ModalBody
          overflow='unset'
          p='0'
        >
          {children}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default ModalDesktop;
